export default __webpack_public_path__ + "static/media/error.6cae8a20.svg";